import { useEffect, useRef, useState } from 'react';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-multi-lang';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { useReactToPrint } from 'react-to-print';

import { useCookies } from 'react-cookie';
import PrintTemplate from './print_template';
import { useAPI } from '../../services/hoc/useAPI';
import { money_unit, Units } from './common';
import {  unit_type } from '../../services/api/api';
interface iBillDetail {
  area: string;
  bill_id: string;

  description: string;
  id: number;
  measures: string;
  piece_code: string;
  piece_count: string;
  price: string;
  total: string;
}
interface iBill {
  bill_no: string;
  client_name:string
  billdetail: iBillDetail[];
  client: {
    id: number;
    name: string;
    account_no: string;
    serial_no: string;
    phone: string;
  };
  client_id: string;
  date: string;
  delivery_order: string;
  discount_amount: string;
  discount_percentage: string;
  discount_value: string;
  id: number;
  items_count: string;
  net_after_tax: string;
  net_after_tax_str: string;
  note: string;
  order_id: string;
  paid: string;
  piece_count: string;
  remains: string;
  seller_name: string;
  tax_amount: string;
  total: string;
  total_net: string;
  type: string;
}

interface  iProps {close:Function,data:any,setWait?:Function}

export const PrintBill = ({close,data,setWait}:iProps) => {
  const [bill, setBill] = useState<iBill | null>(null);
  const [cookie] = useCookies();

 
const api = useAPI()
  const t = useTranslation();
  const componenetRef = useRef(null);

  const handlePrint = useReactToPrint({
   contentRef:componenetRef,
    onAfterPrint: () => close(),
    documentTitle:'',
    
    
  });
  useEffect(() => {
    if (bill) handlePrint();
  }, [bill]);
  useEffect(() => {
 
    if (typeof(data) !=='object') {
      api
        .bills()
        .show({ id: parseInt(data) })
        .then((res: any) => {
         if(setWait) setWait(false)
          if (res.data && res.data.data) {
           
           
            setBill(res.data.data)
          }
        });
    }
  }, [data]);
 
  const handleRow =(ele:any,index=0)=>{
    
    if (!ele) return (<></>)

    return (

      <TableRow key={index}>
      <TableCell style={{ border: '1px solid #a7a4a4' }}
      className='less_spaces'>
        
        {index+1}
      </TableCell>
      
      <TableCell style={{ border: '1px solid #a7a4a4' ,textAlign:'left' ,paddingLeft:'5px'}}
       className='less_spaces'>
        {ele.description  + " "}[{ele.measures}] ({Units[ele.unit as unit_type]})
       
      </TableCell>
    <TableCell style={{ border: '1px solid #a7a4a4' }}
       className='less_spaces'>
        {ele.piece_count}
 
      </TableCell>
      <TableCell style={{ border: '1px solid #a7a4a4' }}
       className='less_spaces'>
        {ele.unit== 'Piece'?ele.area:
        (ele.piece_count * ele.area).toFixed(2)}
        
      </TableCell>
      <TableCell style={{ border: '1px solid #a7a4a4' }}
       className='less_spaces'>
        {parseFloat(ele.price).toFixed(2)} 
        
      </TableCell>
      <TableCell style={{ border: '1px solid #a7a4a4' }}
       className='less_spaces'>
       {parseFloat(ele.total).toFixed(2)}
      </TableCell>
    </TableRow>
    )
  }
const upperPart =(bill:any)=>{
  return (
 <>
          <Grid size={6} display="flex" justifyContent={'flex-end'}>
              <div className="standard-height flex flex-end align_center fs-12 ">

                  <div className=''>
                  { 'R'+bill?.bill_no }
                  </div>
                <div className="label text-right">رقم عرض السعر</div>
              </div>
            </Grid>
            <Grid size={6} display="flex" justifyContent={'flex-end'}>
              <div className="standard-height flex flex-end align_center fs-12 ">

                  <div className=''>
                  { 'Q'+bill?.order_no }
                  </div>
                <div className="label text-right">رقم  الطلبية</div>
              </div>
            </Grid>
            <Grid size={6} display="flex" justifyContent={'flex-end'} >
              <div className="standard-height flex flex-end align_center fs-12">

                  <div className=''>
                  {bill?.date?.replaceAll('-','/')}
                  </div>
                <div className="label text-right">تاريخ عرض السعر</div>
              </div>
            </Grid>
             <Grid size={6} display="flex" justifyContent={'flex-end'} >
              <div className="standard-height flex flex-end align_center fs-12">

                  <div className=''>
                  {bill?.delivery_date?.replaceAll('-','/')}
                  </div>
                <div className="label text-right">{t('delivery_date')}</div>
              </div>
            </Grid>
              <Grid  container size={9}>
                <div className="standard-height flex w-full flex-end align_center fs-12">
             
                  <div className=''>{bill?.client_name}</div>
                  <div className="label text-right">{t('gentlemen')}</div>
                </div>
              </Grid>
 </>
  )
}
const lowerPart =(bill:any)=>{
  return (
    <Grid
    
    container
    size={12}
    rowGap={2}
    justifyContent={'flex-end'}
    rowSpacing={2}
    >
    <Grid
      
      size={12}
      container
      rowGap={3}
      justifyContent="flex-end">
      <Grid  container size={12}>
        <div className="standard-height flex w-full flex-end align_center fs-12">
          {/* <input
             className='bottom-border'
            value={bill?.total}
            style={{ flex: 1, margin: '0 5px', direction: 'rtl' ,fontWeight:''}}
          /> */}
          <div className=''>
          {parseFloat(bill?.total).toFixed(2)} {money_unit} 
          </div>
          <div className="label text-right">{t('total')}</div>
        </div>
      </Grid>
      



      <Grid size={6} container>
        <div className="standard-height flex w-full flex-end align_center fs-12">
          {/* <input
            value={bill?.discount_amount}
            style={{ flex: 1, margin: '0 5px', direction: 'rtl' ,fontWeight:''}}
            className='bottom-border'
          /> */}
          <div className=''>
          {bill?.discount_value } {money_unit}
          </div>
          <div className="label text-right">{t('discount')}</div>
        </div>
      </Grid>

       <Grid size={6} container>
        <div className="standard-height flex w-full flex-end align_center fs-12">
          {/* <input
              className='bottom-border'
            value={bill?.net_after_tax}
            style={{ flex: 1, margin: '0 5px', direction: 'rtl',fontWeight:'' }}
          /> */}
          <div  className=''>
          {bill?.total_net}{money_unit}
          </div>
          <div className="label text-right">{t('total_after_discount')}</div>
        </div>
      </Grid>
     
      <Grid size={6} container>
        <div className="standard-height flex w-full flex-end align_center fs-12">
          {/* <input
             className='bottom-border'
            value={bill?.tax_amount}
            style={{ flex: 1, margin: '0 5px', direction: 'rtl' ,fontWeight:''}}
          /> */}
          <div className=''>
          {bill?.tax_amount }{money_unit}
          </div>
          <div className="label text-right">{t('tax')}</div>
        </div>
      </Grid>
      
      <Grid size={6} container>
        <div className="standard-height flex w-full flex-end align_center fs-12"
      >
          {/* <input
              className='bottom-border'
            value={bill?.net_after_tax}
            style={{ flex: 1, margin: '0 5px', direction: 'rtl' ,fontWeight:''}}
          /> */}
          <div className='' style={{textDecoration:'underline'}}>
          {parseInt(bill?.net_after_tax)} {money_unit} 
          </div>
          <div className="label text-right" style={{textDecoration:'underline'}}>{t('net_after_tax')}</div>
        </div>
      </Grid>
       <Grid size={6} container>
        <div className="standard-height flex w-full flex-end align_center fs-12">
          {/* <input
            value={bill?.discount_amount}
            style={{ flex: 1, margin: '0 5px', direction: 'rtl' ,fontWeight:''}}
            className='bottom-border'
          /> */}
          <div className=''>
          {parseInt(bill?.remains) } {money_unit}
          </div>
          <div className="label text-right">{t('remain')}</div>
        </div>
      </Grid>
      <Grid size={6} container>
        <div className="standard-height flex w-full flex-end align_center fs-12">
          {/* <input
            value={bill?.discount_amount}
            style={{ flex: 1, margin: '0 5px', direction: 'rtl' ,fontWeight:''}}
            className='bottom-border'
          /> */}
          <div className=''>
          {parseInt(bill?.paid) } {money_unit}
          </div>
          <div className="label text-right">{t('paid')}</div>
        </div>
      </Grid>
      {/* <Grid size={12} container>
        <div className="standard-height flex w-full flex-end align_center fs-12">
         
          <div className=''>
          { converter.NumToStr(parseFloat(bill?.net_after_tax).toFixed(2)??0)}
          </div>
          <div className="label text-right">{t('written_number')}</div>
        </div>
      </Grid> */}
      <Grid size={12} container justifyContent={'flex-end'}>
        <div className="standard-height flex w-full flex-end align_center fs-12">
          {/* <input
              className='bottom-border'
            value={ bill?.seller_name}
            style={{ flex: 1, margin: '0 5px', direction: 'rtl' }}
          /> */}
          <div className=''>
          { Boolean(bill?.seller_name)? bill?.seller_name:cookie?.company_info?.name}
          </div>
          <div className="label text-right">{t('seller')}</div>
        </div>
      </Grid>
      <Grid size={12} container justifyContent={'flex-end'}>
        <div className="standard-height flex w-full flex-end align_center fs-12">
          {/* <textarea
            rows={3}
            className='bottom-border'
            value={bill?.note}
            style={{ flex: 1, margin: '0 5px', direction: 'rtl' }}
          /> */}
          <div className=''>
          {bill?.note}
          </div>
          <div className="label text-right">{t('nots')}</div>
        </div>
      </Grid>
    </Grid>
  </Grid>
  )
}
//console.log('bill',bill)
//console.log('cookie',cookie)
  return (
    <div
    ref={componenetRef as any}
    className="printMe"
    style={{minHeight:'auto',height:'auto'}}

  >
     <PrintTemplate
   
    title_ar='عرض السعر'

    >

   

 
      <Grid container rowGap={3}>
      
        <Grid  container padding={1} size={12}>
        
            <Grid  container size={12} rowGap={2} justifyContent={'flex-end'}>
              {
                upperPart(bill)
              }
              <Grid size={12} padding={0}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ border: '1px dashed black' }}>
                        <span>تسلسل</span>
                     
                      </TableCell>
                     
                      <TableCell style={{ border: '1px dashed black' }}>
                        <div
                          style={{
                            display: 'flex',
                            height: '100%',
                            width: '100%',
                            justifyContent: 'space-between',
                            
                          }}>
                          <span style={{ padding: '10px' }}>البيان</span>
                         
                        </div>
                      </TableCell>
                       <TableCell
                        style={{
                          border: '1px dashed black',
                        }}>
                        <div
                          style={{
                            display: 'flex',
                            height: '100%',
                            width: '100%',
                            justifyContent: 'space-between',
                          }}>
                          <div style={{ padding: '10px' }}>العدد</div>
                        
                        </div>
                      </TableCell>
                    
                      <TableCell style={{ border: '1px dashed black' }}>
                        <span>الكمية</span>

                      </TableCell>
                      <TableCell style={{ border: '1px dashed black' }}>
                        <span>سعر المبيع (ريال)</span>
                       
                      </TableCell>
                      <TableCell style={{ border: '1px dashed black' }}>
                        <span>الاجمالي </span>
                        
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                 {        
        bill?.billdetail.map((ele,index)=>
                  handleRow(ele,index))
                 
                 }
                  </TableBody>
                </Table>
              </Grid>
           {
            
            lowerPart(bill)
           }
            </Grid>
          </Grid>
        </Grid>
       
   
 
                       </PrintTemplate>
      </div>
  );
};
